import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetProductGroupingsByOrderInput } from './GetProductGroupingsByOrderInput';
import { GetProductGroupingsByOrderOutput } from './GetProductGroupingsByOrderOutput';

export class GetProductGroupingsByOrderService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GetProductGroupingsByOrderInput): Promise<Result<GetProductGroupingsByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetProductGroupingsByOrderOutput>>(`${this.baseUrlSislogApi}/v2/product-grouping/${input.orderId}`);
    return promise;
  }
}